import { FamilyNewsletterOptionsEnum } from "@/consts/newsletter";
import { disableFamilyNewsletterOption } from "@/utils/disableFamilyNewsletterOption";

export const setConciergeCategory = (facility: any, value: boolean) => {
    facility.featureConcierge = value;
    facility.additionalServicesEnabled = value;
    facility.additionalServicesBookingsEnabled = value;

    if (!value) {
      disableFamilyNewsletterOption(facility, FamilyNewsletterOptionsEnum.ConciergeEventsAttended);
      disableFamilyNewsletterOption(facility, FamilyNewsletterOptionsEnum.NewServicesBooked);
    }
 }

export const setLifestyleCategory = (facility: any, value: boolean) => {
    facility.featureLifestyle = value;
    facility.isEnableWeeklyLifestyleEventsReport = value;
    facility.isStaffHubCalendar = value;
    facility.lifestyleProgramsTileOnMyHubEnabled = value;
    facility.isEnableResidentEventPictures = value;
    facility.isCanCreateWings = value;

    if(!value) {
      facility.isOptInLifestylePrograms = value;
      facility.isEnableRoomBooking = value;

      disableFamilyNewsletterOption(facility, FamilyNewsletterOptionsEnum.LifestyleEventsAttended);
    }
}